import { LocationTree } from "./LocationTree";

export default LocationTree;
